/**
 * @name LoadImages.js
 * @description 非同期関数（async function）を使って画像を読み込む
 */

// 画像のURLを取得
let imgArray = [...document.querySelectorAll('img')]

// 画像を読み込む関数
async function loadImages() {
    const promises = [];
    const images = [];

    // 画像ファイルを1枚ずつ読み込み
    imgArray.forEach((url) => {
        let promise = new Promise((resolve) => {
            const img = new Image();
            img.addEventListener("load", () => resolve());
            img.src = url.src;
            images.push(img);
        });
        promises.push(promise);
    });
    await Promise.all(promises);
    return images;
}

export default loadImages;